import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionRegistryAssociateOption extends ConditionRegistryCategory {
    label = 'Antwortoption';
    constructor(parent) {
        super(parent);
        super.init();
    }
    associateoption_isSomeAssociated = () => new ConditionRegistryItem({
        parent: this,
        label: 'Wurde ein Associate zugeordnet',
        eval: ({ associateOption }) => {
            return (!!associateOption &&
                associateOption.associateOptionUI &&
                associateOption.associateOptionUI.wasAtLeastOneAssociated);
        }
    });
    associateoption_isBestDraggingTarget = () => new ConditionRegistryItem({
        parent: this,
        label: 'Ist Bestes Dragging Target',
        eval: ({ question, option }) => {
            const q = question;
            const association = q.currentAssociation;
            if (!association)
                return false;
            if (!association.inner.aspectDraggable.isDragging)
                return false;
            if (association.actorIntersect.mainIntersectingActorsOfType('option') === option)
                return true;
            return false;
        }
    });
    associateoption_shouldShowTemporaryFalseFeedback = () => new ConditionRegistryItem({
        parent: this,
        label: 'shouldShowTemporaryFalseFeedback_1500ms',
        eval: ({ associateOption }) => {
            if (!associateOption || !associateOption.associateOptionUI)
                return false;
            return associateOption.associateOptionUI.shouldShowTemporaryFalseFeedback_1500ms;
        }
    });
    associateoption_hasPending = () => new ConditionRegistryItem({
        parent: this,
        label: 'Mind. 1 Associate muss noch zgeordnet werden',
        eval: ({ associateOption }) => {
            if (!associateOption || !associateOption.associateOptionUI)
                return false;
            return !associateOption.associateOptionUI.areAllAssigned;
        }
    });
    associateoption_areAllAssigned = () => new ConditionRegistryItem({
        parent: this,
        label: 'Alle Associations mit diesem Target sind zugeordnet',
        eval: ({ associateOption }) => {
            if (!associateOption || !associateOption.associateOptionUI)
                return false;
            return associateOption.associateOptionUI.areAllAssigned;
        }
    });
    associateoption_areAllCorrectlyAssigned = () => new ConditionRegistryItem({
        parent: this,
        label: 'Alle mit diesem Target sind zugeordnet und korrekt',
        eval: ({ associateOption }) => {
            if (!associateOption || !associateOption.associateOptionUI)
                return false;
            return associateOption.associateOptionUI.areAllCorrectlyAssigned;
        }
    });
}
